module.exports = __webpack_public_path__ + "img/icon_bgm.a85e4fe9.png";